import React, { useEffect } from "react";
import { Link } from 'react-router-dom'
import { useAuthContext } from '../backend/UseAuth'
import { useState } from 'react'
import { useSignup } from '../backend/Register'
import TableData from "../backend/TableData";
import { getDoc, collection, doc, getFirestore, getDocs, query, onSnapshot, orderBy, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import moment from "moment";


export default function Contributions() {
    const db = getFirestore();
    const auth = getAuth();
    const { user } = useAuthContext()
    const { logout } = useSignup()
    const handleSubmit = (e) => {
        logout()
    }
    const [date, setDate] = useState("")
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [Alldocs, setAlldocs] = useState([]);
    const [singleDoc, setSingledoc] = useState([]);
    const [menuItems, setMenuItems] = useState([]);
    const [selectedRow, setSelectedRow] = useState('');
    const [docid, setID] = useState('');

    let data;
    const newCityRef = doc(collection(db, "contributions"));
    useEffect(() => {

        getDoc(doc(db, "users", user.uid)).then(docSnap => {
            if (docSnap.exists()) {
                setSingledoc(docSnap.data());
            } else {
                console.log("No such document!");
            }
        })

        const q = query(collection(db, 'contributions'), orderBy('Score', 'asc'));
        const unsubscribe = onSnapshot(
            q,
            snapshot => {
                if (!snapshot.empty) {
                    setMenuItems(
                        snapshot.docs.map(doc => ({
                            id: doc.id,
                            ...doc.data(),
                        }))
                    );
                }
                setIsLoading(false);
            },
            err => {
                setError(err.message);
                console.error(err.message);
            }
        );

        console.log(menuItems);
        return () => {
            unsubscribe();
        };

    }, [])

    const handleSelectedRow = (id) => {
        setSelectedRow({ id });
        const db = getFirestore();
        const user2 = auth.currentUser;
        const docRef = doc(db, "contributions", id);
        const data = {
            Status: 'Accepted',
            ApprovedBy: singleDoc.firstname + " " + singleDoc.lastname,
            DateApproved: moment().format('ll'),
        }

        updateDoc(docRef, data)
            .then(docRef => {

            })
            .catch(error => {
                console.log(error);
            })

    };


    return (
        <React.Fragment>

            <div className="overlay"></div>



            <div className="main-body-wrapper d-flex">

                <div className="sidebar-wrapper bg--accent">
                    <div className="sidebar-inner">
                        <ul className="sidebar-menu">
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/contributions" className="sidebar-menu-link"><img src="assets/images/icon/menu1.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/tests" className="sidebar-menu-link"><img src="assets/images/icon/menu2.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/domain" className="sidebar-menu-link"> <img src="assets/images/icon/menu3.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/visualization" className="sidebar-menu-link"> <img src="assets/images/icon/menu4.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/lists" className="sidebar-menu-link"> <img src="assets/images/icon/menu5.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/profile" className="sidebar-menu-link"> <img src="assets/images/icon/menu6.png" alt="icon" />
                                    </Link>
                                }
                            </li>

                        </ul>
                    </div>
                </div>

                <div className="main-content">
                    <div className="main-content-inner">

                        <div className="top-menu-wrapper bg-white">
                            <div className="top-menu-inner d-flex flex-wrap gap-2 justify-content-between">
                                <div className="d-sm-block">
                                    <div className="sidebar-toggler fs--20px d-md-none"><i className="fas fa-bars"></i></div>
                                </div>
                                <a href="contributions.html" className="logo"><img src="assets/images/logo.png" alt="logo" /></a>
                                <ul className="top-menu d-flex flex-wrap gap-3">
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-bell"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <div className="dropdown-header">
                                                    <div className="d-flex flex-wrap justify-content-between pb-2">
                                                        <h6>Notifications</h6>
                                                        <span>Mark all as read</span>
                                                    </div>
                                                    <ul className="notification">
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">Doreen P</h6>
                                                                    <p> </p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">Jann O</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">Jeffery L</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-user"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <ul className="notification">
                                                    <li className="notification-item border-0">
                                                        <div className="d-flex gap-3">
                                                            <div className="notification-item__thumb">
                                                                <i className="fas fa-user"></i>
                                                            </div>
                                                            <div className="notification-item__content">
                                                                {
                                                                    singleDoc.firstname && <h6 className="notification-item__content-name">
                                                                        {singleDoc.firstname + " " + singleDoc.lastname}
                                                                    </h6>
                                                                }
                                                                <p>Admin</p>
                                                                {
                                                                    <Link to="/profile" className="mt-3 d-block fs--14px fw-semibold">Edit Profile
                                                                    </Link>
                                                                }
                                                                {
                                                                    <Link to="/" onClick={handleSubmit} className="mt-1 d-block fs--14px fw-semibold text--danger">  Log Out
                                                                    </Link>
                                                                }


                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="main-content-inner-inner">
                            <div className="card custom--card">
                                <div className="card-header pb-0">
                                    <h4 className="title">Contributions</h4>
                                    <ul className="nav-tabs nav filter mt-2">
                                        <li className="nav-item"><a href="#approved-contributions" className="nav-link active" data-bs-toggle="tab">Approve Contributions</a></li>
                                        <li className="nav-item"><a href="#all-contributions" className="nav-link" data-bs-toggle="tab">All Contributions</a></li>

                                    </ul>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex flex-wrap justify-content-between gap-3 mb-4">
                                        <div className="search-wrapper">
                                            <form action="">
                                                <div className="form-group">
                                                    <input type="text" className="form-control form--control ps-5" />
                                                    <button className="btn fs--18px border-0 btn--icon" type="submit"><i className="fas fa-search"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="d-flex flex-wrap gap-3">
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <div className="tab-pane show fade active" id="approved-contributions">
                                            <table className="table table--responsive--xl2">
                                                <thead>
                                                    <tr>
                                                        <th>Original Language</th>
                                                        <th>Original Sentence</th>
                                                        <th>Translated Language</th>
                                                        <th>Translated Sentence</th>
                                                        <th>Contributor</th>
                                                        <th>Score</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(
                                                        menuItems.map(({ id, originallanguage, originalsentence, translatedlanguage, translatedsentence, Contributor, Score, Status }, index) => Status === "Pending" ? (

                                                            <tr key={index} className={`table-row ${selectedRow.id === id}`}>
                                                                <td data-label="Original Language">{originallanguage}</td>
                                                                <td data-label="Original Sentence">{originalsentence}</td>
                                                                <td data-label="Translated Language">{translatedlanguage}</td>
                                                                <td data-label="Translated Sentence">{translatedsentence}</td>
                                                                <td data-label="Contributor">
                                                                    <div className="position-relative d-inline-block">
                                                                        <a href="#" className="btn btn--md btn--base dropdown-hover">{Contributor} <i className="las la-angle-down"></i></a>
                                                                        <div className="dropdown-wrapper">
                                                                            <div className="dropdown-inner">
                                                                                <ul className="list list-simple">
                                                                                    <li className="d-flex justify-content-between">
                                                                                        <span className="fw-semibold text-start">Education</span>
                                                                                        <span className="text-end">Secondary</span>
                                                                                    </li>
                                                                                    <li className="d-flex justify-content-between">
                                                                                        <span className="fw-semibold text-start">Spoken Language(s)</span>
                                                                                        <span className="text-end">Filipino, Cebuano</span>
                                                                                    </li>
                                                                                    <li className="d-flex justify-content-between">
                                                                                        <span className="fw-semibold text-start">Fluency</span>
                                                                                        <span className="text-end">Native</span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{Score}</td>
                                                                <td data-label="Status">
                                                                    <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                                        <button className="btn btn--success btn--sm btn--icon" onClick={() => handleSelectedRow(id)}> <i className="fas fa-check"></i></button>
                                                                        <a href="#" className="btn btn--danger btn--sm remove-item btn--icon"><i className="fas fa-times"></i></a>
                                                                        <a data-label="Edit"><button className="btn btn--warning btn--sm btn--icon"><i className="fas fa-pen"></i></button></a>
                                                                    </div>
                                                                </td>

                                                            </tr>
                                                        ) : (
                                                            <tr></tr>
                                                        )

                                                        ))}



                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="tab-pane fade" id="all-contributions">
                                            <table className="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Original Language</th>
                                                        <th>Original Sentence</th>
                                                        <th>Translated Language</th>
                                                        <th>Translated Sentence</th>
                                                        <th>Contributor</th>
                                                        <th>Approved by</th>
                                                        <th>Date Approved</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {(
                                                        menuItems.map(({ originallanguage, originalsentence, translatedlanguage, translatedsentence, Contributor, ApprovedBy, DateApproved, Status }) => Status === "Accepted" ? (

                                                            <tr>
                                                                <td data-label="Original Language">{originallanguage}</td>
                                                                <td data-label="Original Sentence">{originalsentence}</td>
                                                                <td data-label="Translated Language">{translatedlanguage}</td>
                                                                <td data-label="Translated Sentence">{translatedsentence}</td>
                                                                <td data-label="Contributor">{Contributor}</td>
                                                                <td data-label="Approved By">{ApprovedBy}</td>
                                                                <td data-label="Date Approved">{DateApproved}</td>
                                                            </tr>
                                                        ) : (
                                                            <tr>

                                                            </tr>
                                                        )

                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >

    )

}
